<template>
    <div>
        <v-row class="my-10">
            <v-col class="text-center">
                <div class="d-inline-block pb-6 px-10" style="border-bottom: 1px solid grey;">
                    
                    <span class="product-title" v-if="$route.params.url != 'new'">{{category.name}}</span>
                    <span class="product-title" v-else>
                        <span class="bold">New</span> <span>Products</span></span>
                    <!-- <span class="bold product-title">BEAUTY</span> <span class="product-title">ALWAYS WINS</span> -->
                </div>
            </v-col>
        </v-row>

        <v-row class="mb-12" justify="center">


            <template v-for="(product, product_id) in products">

                <template v-if="!product.favorite || $vuetify.breakpoint.xs">
                
            
                    <v-col cols="12" sm="5" :key="'product-'+product_id" class="product-column px-sm-12 mx-sm-12" @mouseover="productOver = product_id" @mouseout="productOver = -1" v-bind:class="{'opac':productOver != -1 && productOver != product_id}" v-if="product.category.url == $route.params.url || ($route.params.url == 'new' && product.new) || (isInSecondCategory(product))">
                        <router-link :to="'/product/'+product.url" class="mb-5 d-block not-text-decoration">
                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+product.cover.path" :contain="true" class="mb-5"></v-img>
                        </router-link>

                        <router-link :to="'/product/'+product.url" class="menu-links d-inline-block not-text-decoration furniture-link uppercase">
                            <span class="bold">{{product.productNameLabelBold}}</span> <span>{{product.productNameLabel}}</span>
                            <div class="animation-line"></div>
                        </router-link>

                    </v-col>
                </template>
            </template>

            <v-col cols="12" sm="5">
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    data(){
        return {
            products:[],
            productOver: -1,
            category: {}
        }
    },
    methods: {
        isInSecondCategory: function(item){

            if(item.category2 != undefined){
                if(item.category2.url == this.$route.params.url){
                    return true;
                }
            }

            return false;
        },
    },
    mounted: function(){
        var aux = this;
        gtag('config', 'UA-26953667-1', {
            'page_title' : 'FurnitureCategory',
            'page_path': '/furniture/'+aux.$route.params.url
        });
    },
    beforeMount: function(){
        fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/Products?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    populate: 2, // resolve linked collection items
                    sort:{
                        url: 1
                    },
                    filter: {
                      showProduct: true,
                    }
                })
            }
        )
        .then(res => res.json())
        .then(res => (this.products = res.entries));



        var aux = this;
        fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/Categories?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                filter: {
                    url: this.$route.params.url
                },
                populate: 1 // resolve linked collection items
                })
            }
        )
        .then(res => res.json())
        .then(res => (aux.category = res.entries[0]))
    },
    watch:{
        $route(to,from){
            fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/Products?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    populate: 2, // resolve linked collection items
                    sort:{
                        url: 1
                    },
                    filter: {
                      showProduct: true,
                    }
                })
            }
        )
        .then(res => res.json())
        .then(res => (this.products = res.entries));



        var aux = this;
        fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/Categories?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                filter: {
                    url: this.$route.params.url
                },
                populate: 1 // resolve linked collection items
                })
            }
        )
        .then(res => res.json())
        .then(res => (aux.category = res.entries[0]))
        }
    }
}
</script>
